import AdminCrud from "@/components/AdminCrud";

export default function AdminEvents() {
  return (
    <AdminCrud
      endpoint="/events"
      singular="event"
      testIdPrefix="admin-events"
      listColumns={[
        { key: "title", label: "Title" },
        { key: "date", label: "Date" },
        { key: "location", label: "Location" },
        { key: "format", label: "Format" },
      ]}
      fields={[
        { key: "title", label: "Title", type: "text", required: true, colSpan: 2 },
        { key: "date", label: "Date", type: "date", required: true },
        { key: "time", label: "Time (display)", type: "text" },
        { key: "location", label: "Location", type: "text", required: true, colSpan: 2 },
        { key: "format", label: "Format", type: "select", options: ["In-Person", "Virtual", "Hybrid"], required: true },
        { key: "cme_credits", label: "CME credits", type: "number", step: "0.5" },
        { key: "capacity", label: "Capacity", type: "number" },
        { key: "image_url", label: "Image URL", type: "text" },
        { key: "external_url", label: "External registration URL", type: "text", colSpan: 2 },
        { key: "description", label: "Short description", type: "textarea", required: true, colSpan: 2, rows: 3 },
        { key: "long_description", label: "Full description", type: "textarea", colSpan: 2, rows: 6 },
      ]}
    />
  );
}
